// extracted by mini-css-extract-plugin
module.exports = {"root":"_2XjkYxRZ_4zVKAyAkN2QKG"};